import { Button, DialogActions, DialogContent } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { MUIVariant } from '../util/palette';

export interface Action {
	text: string;
	onClick?: () => any;
	disabled?: boolean;
	variant?: MUIVariant;
	color?:
		| 'neutralButton'
		| 'primary'
		| 'secondary'
		| 'inherit'
		| 'info'
		| 'success'
		| 'warning'
		| 'error'
		| 'navLink';
}

interface Props {
	open: boolean;
	onClose?: () => void;
	children?: any;
	title?: string | JSX.Element;
	actions?: Action[];
}

export default function DefaultDialog(props: Props) {
	const { open, children, onClose, actions, title } = props;

	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};

	const buttons = actions?.map(
		({ text, onClick, disabled, color, variant }, index) => {
			return (
				<Button
					key={index}
					onClick={onClick}
					disabled={disabled}
					color={color ? color : 'primary'}
					variant={variant ? variant : 'contained'}
					sx={{
						margin: '5px',
						whiteSpace: 'nowrap',
						cursor: disabled ? 'initial' : 'pointer',
					}}
				>
					{text}
				</Button>
			);
		},
	);

	return (
		<Dialog fullWidth onClose={handleClose} open={open}>
			<DialogTitle id='dialog-title'>{title}</DialogTitle>
			<DialogContent>{children}</DialogContent>
			<DialogActions>{buttons}</DialogActions>
		</Dialog>
	);
}
